import React from 'react';
import {useFormikContext} from 'formik';
import _ from 'lodash';
import styled from 'styled-components';

import {useFormatters} from '../../data-ui/FormattersContext';

import {Btn, Icon} from '../../ui-toolkit/index';
import {Select} from '../../ui-toolkit/indexExportV2';

export function FilterPanel({entityType, arrayHelpers, handleSubmit, validFilterFormatters, t}) {
    const {setFieldValue, values} = useFormikContext();
    const formatters = useFormatters();

    if (_.isEmpty(validFilterFormatters)) return null;

    async function setFilters(action) {
        if (action.action === 'select-option') {
            let id = action.option.value;
            let filterFormatter = _.find(validFilterFormatters, {id: id});

            if (filterFormatter == null) return null;

            let filterComponent = filterFormatter.component;
            arrayHelpers.unshift(filterComponent.initialFormData(action.option.formatter));
        } else if (action.action === 'remove-value') {
            arrayHelpers.remove(_.findIndex(values.filters, {id: action.removedValue.value}));
        } else if (action.action === 'clear') {
            await setFieldValue('filters', []);
            handleSubmit();
        } else if (action.action === 'pop-value') {
            arrayHelpers.pop();
        }
    }

    const availableFilterOptions = _.map(validFilterFormatters, (f) => ({
        label: f.displayName,
        value: f.id,
        formatter: f,
    }));

    return (
        <>
            <FilterContainer>
                <Select
                    label={t('filterPanel.chooseFilter')}
                    raw
                    value={_.filter(availableFilterOptions, (fo) => _.some(values.filters, (f) => f.id === fo.value))}
                    options={availableFilterOptions}
                    onChange={(_, action) => {
                        setFilters(action);
                    }}
                    isClearable={false}
                    isMulti={true}
                    isSearchable={true}
                    hideSelectedOptions={true}
                    controlShouldRenderValue={false}
                    placeholder={t('filterPanel.addFilter')}
                />
            </FilterContainer>
            {values.filters.map((filter, ix) => {
                let filterFormatter = _.find(validFilterFormatters, {id: filter.id});
                if (filterFormatter == null) return null;
                let filterComponent = filterFormatter.component;
                let Filter = filterComponent.component;
                return (
                    <FilterContainer
                        key={filter.id}
                        closeBtnText={t('generalShared.clear')}
                        onClose={() => {
                            arrayHelpers.remove(ix);
                            handleSubmit();
                        }}>
                        <Filter
                            index={ix}
                            config={filterFormatter}
                            value={filter.value}
                            entityType={entityType}
                            formatters={formatters}
                        />
                    </FilterContainer>
                );
            })}
        </>
    );
}

const Wrapper = styled.div`
    position: relative;
    margin-bottom: var(--space-lg);

    > ${Btn} {
        position: absolute;
        top: -2px;
        right: 0;
        line-height: 0;
        z-index: var(--z-index-dropdown-btn);
        font-size: var(--text-size-x-small);

        ${Icon.Wrapper} svg {
            height: var(--text-size-x-small);
            width: var(--text-size-x-small);
        }
    }
`;

const FilterContainer = ({children, closeBtnText, onClose}) => {
    return (
        <Wrapper>
            {closeBtnText && (
                <Btn type="button" color="danger" size="sm" link onClick={onClose}>
                    <Icon name="Close" />
                    {closeBtnText}
                </Btn>
            )}
            {children}
        </Wrapper>
    );
};
